import {
    AppFeedbackApi,
    AppFeedbackReviewCandidateDto,
    AppFeedbackReviewCountDto,
    AppFeedbackReviewDecisionDto,
    AppFeedbackReviewDetailDto,
    AppFeedbackReviewListDto,
    AppFeedbackReviewListFilter,
    AppFeedbackReviewSettingsDto,
    AppFeedbackReviewSettingsUpdateResultDto,
    AppFeedbackRoutingOptionsDto,
    CreateAppFeedbackDto,
    CreateAppFeedbackResponseDto,
    DiscardAppFeedbackDto,
    ReleaseAppFeedbackDto,
    UpdateAppFeedbackReviewSettingsDto,
} from "breuer-supercharged-sdk";
import { getClient } from "./client";

export class AppFeedbackService {
    private static instance: AppFeedbackService;

    private constructor() { }

    public static getInstance(): AppFeedbackService {
        if (!AppFeedbackService.instance) {
            AppFeedbackService.instance = new AppFeedbackService();
        }
        return AppFeedbackService.instance;
    }

    private client = new AppFeedbackApi(undefined, undefined, getClient())

    async createFeedback(dto: CreateAppFeedbackDto): Promise<CreateAppFeedbackResponseDto> {
        const response = await this.client.createAppFeedback(dto);
        return response.data;
    }

    async getRoutingOptions(): Promise<AppFeedbackRoutingOptionsDto> {
        return (await this.client.getAppFeedbackRoutingOptions()).data;
    }

    async listReview(status: AppFeedbackReviewListFilter, limit: number, offset: number): Promise<AppFeedbackReviewListDto> {
        return (await this.client.listAppFeedbackReview(undefined, status, limit, offset)).data;
    }

    async countReview(): Promise<AppFeedbackReviewCountDto> {
        return (await this.client.countAppFeedbackReview()).data;
    }

    async getReview(id: string): Promise<AppFeedbackReviewDetailDto> {
        return (await this.client.getAppFeedbackReview(id)).data;
    }

    async releaseReview(id: string, dto: ReleaseAppFeedbackDto): Promise<AppFeedbackReviewDecisionDto> {
        return (await this.client.releaseAppFeedbackReview(id, dto)).data;
    }

    async discardReview(id: string, dto: DiscardAppFeedbackDto): Promise<AppFeedbackReviewDecisionDto> {
        return (await this.client.discardAppFeedbackReview(id, dto)).data;
    }

    async getReviewSettings(): Promise<AppFeedbackReviewSettingsDto> {
        return (await this.client.getAppFeedbackReviewSettings()).data;
    }

    async updateReviewSettings(dto: UpdateAppFeedbackReviewSettingsDto): Promise<AppFeedbackReviewSettingsUpdateResultDto> {
        return (await this.client.updateAppFeedbackReviewSettings(dto)).data;
    }

    async listReviewCandidates(): Promise<AppFeedbackReviewCandidateDto[]> {
        return (await this.client.listAppFeedbackReviewCandidates()).data;
    }
}
